// This import loads the firebase namespace along with all its type information.
import MediaAnalytics from './media-analytics-model'

export async function load_mediaAnalyticss(): Promise<MediaAnalytics[]> {
  throw 'Not implemented'
}

export async function delete_mediaAnalytics(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaAnalytics(): Promise<MediaAnalytics> {
  throw 'Not implemented'
}
